import React, { Component } from 'react';
import { STATUS_LABEL_DETAIL, TEXT_LABEL_SUMMARY } from './../consts';
import CheckBoxApproval from './CheckBoxApproval.jsx';
import style from "./DetailsPayment.css";

class RowDetailPayment extends Component {
    constructor(props) {
        super(props)
        this.state = {
            idPartner: this.props.idPartner,
            list: this.props.list,
            dtoAdd: this.props.list.dtoAdd,
            reason: this.props.list.reasonDtoAdd
        };

        this.handleCheckboxChange = (evt) => {
            const status = evt.target.checked;
            const { idPartner, list } = this.state;
            this.props.approvePayment(idPartner, list.listId, status, true);
        };

        this.handleChange = (evt) => {
            const { value, name } = evt.target;
            this.setState({ [name]: value });
        };

        this.onSaveDtoAddReason = () => {
            const { idPartner, list, dtoAdd, reason } = this.state;
            if (reason === '' || dtoAdd === 0)
                this.dtoAddInput.focus();

            this.props.updateDtoAddReason(idPartner, list.listId, dtoAdd, reason)
        };

        this.styleStoreIsClosed = (data) => {
            if (typeof data !== 'undefined') {
                if(data.estado_inventario == 3){
                    return {
                        backgroundColor: '#F4CCCC'
                    };
                }
                if(data.deterioroId != null){
                    return {
                        backgroundColor: '#DCC6E0'
                    };
                }
                if (data.storeIsClosed) {
                    return {
                        backgroundColor: '#D9E9F9'
                    };
                }
            }
        };
    }

    render() {
        const { idx, list } = this.props;
        const {
            leader, base, amount, inventoryFormatDate,
            clientName, storeName, storeRegion, storeComuna,
            payrollStatus, serviceStatusApproved
        } = list;

        return (
            <tr key={idx} style={this.styleStoreIsClosed(list)}>
                <td>{inventoryFormatDate}</td>
                <td>{clientName}</td>
                <td>{storeRegion}</td>
                <td>{storeComuna}</td>
                <td>{storeName}</td>
                <td>{base.toLocaleString("es-CL", { style: "currency", currency: "clp" })}</td>
                <td className={style.DetailsPayment__tdDtoAdd} style={{ display: this.props.showDetailsTotal ? '' : 'none' }}>
                    <input
                        type="number"
                        name="dtoAdd"
                        value={this.state.dtoAdd}
                        ref={(input) => { this.dtoAddInput = input; }}
                        onChange={this.handleChange}
                        onBlur={this.onSaveDtoAddReason}
                        disabled={this.state.reason === '' || payrollStatus}
                    />
                </td>
                <td className={style.DetailsPayment__tdComment} style={{ display: this.props.showDetailsTotal ? '' : 'none' }}>
                    <input
                        type="text"
                        name="reason"
                        value={this.state.reason}
                        onChange={this.handleChange}
                        onBlur={this.onSaveDtoAddReason}
                        disabled={payrollStatus}
                    />
                </td>
                <td>{leader.nombreCorto}</td>
                <td>{amount.toLocaleString("es-CL", { style: "currency", currency: "clp" })}</td>
                <td style={{ textAlign: "center" }}>
                    <span className={`label ${STATUS_LABEL_DETAIL[payrollStatus ? payrollStatus : 0]}`}>
                        {TEXT_LABEL_SUMMARY[payrollStatus ? payrollStatus : 0]}
                    </span>
                </td>
                <td style={{ textAlign: "center" }}>
                    <span className={`label ${STATUS_LABEL_DETAIL[serviceStatusApproved]}`}>
                        {TEXT_LABEL_SUMMARY[serviceStatusApproved]}
                    </span>
                </td>
                <td>
                    <CheckBoxApproval
                        id={idx}
                        handleCheckboxChange={this.handleCheckboxChange}
                        isChecked={serviceStatusApproved === 4}
                        //isDisabled={payrollStatus}
                    />
                </td>
                <td style={{ textAlign: "center" }}>
                    {this.state.list.servicio_aprobado_op == 1
                        ? <span className='glyphicon glyphicon-ok text-success'></span>
                        : <span className='glyphicon glyphicon-remove text-danger'></span>}
                </td>
            </tr>
        )
    }
}

export default RowDetailPayment;


export class RowDetailDeterioro extends Component {
    constructor(props) {
        super(props)
        this.state = {
            idPartner: this.props.idPartner,
            list: this.props.list,
        };

        this.styleStoreIsClosed = (data) => {
            if (typeof data !== 'undefined') {
                if(data.estado_inventario == 3){
                    return {
                        backgroundColor: '#F4CCCC'
                    };
                }
                if(data.deterioroId != null){
                    return {
                        backgroundColor: '#DCC6E0'
                    };
                }
                if (data.storeIsClosed) {
                    return {
                        backgroundColor: '#D9E9F9'
                    };
                }
            }
        };
    }

    render() {
        const { idx, list } = this.props;
        const {
            leader, base, amount, inventoryFormatDate,
            clientName, storeName, storeRegion, storeComuna,
            payrollStatus, serviceStatusApproved,
            deterioro
        } = list;

        const {sku, valor_imputable, cantidad_producto, valor_producto, comentario} = deterioro;

        return (
            <tr key={idx} style={this.styleStoreIsClosed(list)}>
                <td></td>
                <td colSpan={2}>Deterioro</td>
                <td>{comentario}</td>
                <td colSpan={1}>
                    <div>{`SKU: ${sku}`}</div>
                    <div>{`Cant: ${cantidad_producto}`}</div>
                </td>
                <td>
                    <div>{valor_producto.toLocaleString("es-CL", { style: "currency", currency: "clp" })}</div>
                    <div>{`${(valor_producto * cantidad_producto).toLocaleString("es-CL", { style: "currency", currency: "clp" })} (x${cantidad_producto}) `}</div>
                </td>
                <td></td>
                <td style={{color: 'red'}}>{`-${valor_imputable.toLocaleString("es-CL", { style: "currency", currency: "clp" })}`}</td>
                <td style={{ textAlign: "center" }}>
                </td>
                <td style={{ textAlign: "center" }}>
                </td>
                <td>
                </td>
                <td style={{ textAlign: "center" }}>
                    {this.state.list.servicio_aprobado_op == 1
                        ? <span className='glyphicon glyphicon-ok text-success'></span>
                        : <span className='glyphicon glyphicon-remove text-danger'></span>}
                </td>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/RowDetailPayment.jsx